import {DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {Component, inject, Input} from '@angular/core';

import {appRoutes} from "@numizmat/constants";
import {environment} from "@numizmat/environments";

import {AdType} from "@numizmat/enumerations";
import {ImageComponent} from "../image/image.component";
import {ImageViewerService} from "@numizmat/services/common";

import {ToggleAdLikeButtonComponent} from "../toggle-ad-like-button/toggle-ad-like-button.component";

export interface AdCardData {
  adId: string;
  title: string;
  imageUrl: string;
  price: number;
  adType: AdType;
  expiryDate: Date;
  userAdLikeId?: string;
  additionalImageIds: string[];
}

@Component({
    selector: 'nz-ad-card',
    imports: [
        DatePipe,
        ImageComponent,
        RouterLink,
        ToggleAdLikeButtonComponent
    ],
    templateUrl: './ad-card.component.html',
    styleUrl: './ad-card.component.scss'
})
export class AdCardComponent {
  private imageViewerService: ImageViewerService = inject(ImageViewerService);

  @Input() data!: AdCardData;
  @Input() bordered: boolean = false;
  @Input() disabledPreview: boolean = false;
  @Input() disabledLikeButton: boolean = false;
  @Input() disabledPreviewImages: boolean = false;

  protected readonly AdTypeEnum = AdType;
  protected readonly appRoutes = appRoutes;

  protected onPreviewImages(): void {
    if (!this.disabledPreviewImages) {
      const imageUrls: string[] | undefined = this.data.additionalImageIds?.map(x => {
        return `${environment.apiImageAdUrl}/additional/${this.data.adId}/${x}`;
      });
      if (!!imageUrls) {
        this.imageViewerService.setImages(imageUrls);
      }
    }
  }
}
